import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loop from "./loop";
import ReapITDDM from "./reapitddm";
import ReapITQAC from "./reapitqac";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/reapit/ddm" element={<ReapITDDM />} />
        <Route path="/reapit/qac" element={<ReapITQAC />} />
        <Route path="/loop" element={<Loop />} />
        <Route path="/" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
